document.addEventListener("DOMContentLoaded", function () {
  const lazySections = document.querySelectorAll(".lazy-section");

  if (lazySections.length === 0) {
    console.warn("No elements with class 'lazy-section' found.");
    return; // Stop execution if no elements are found
  }

  // Intersection Observer options
  const options = {
    root: null, // relative to viewport
    rootMargin: "0px", // trigger when section is fully in the viewport
    threshold: 0.1, // trigger when at least 10% of the section is in view
  };

  // Callback to handle intersection
  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      console.log(entry.target, "isIntersecting:", entry.isIntersecting); // Debugging

      if (entry.isIntersecting) {
        entry.target.classList.add("loaded");
        observer.unobserve(entry.target); // Stop observing once the section is loaded
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, options);

  lazySections.forEach((section) => {
    console.log("Observing:", section); // Debugging
    observer.observe(section); // Start observing each lazy-load section
  });
});
